import { gql } from './generated/gql';

// eslint-disable-next-line slab-graphql/no-unused-colocated-fragments
export default gql(`
  # eslint-disable-next-line slab-graphql/no-unused-fields
  query unorganized(
    $afterCursor: String
    $first: Int = 20
    $filter: UnorganizedPostsFilter
    $orderBy: UnorganizedPostsOrder
  ) {
    unorganized(
      first: $first
      after: $afterCursor
      filter: $filter
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`);
